
import React, { useEffect, useRef, PropsWithChildren, useState } from "react";
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe, Stripe, StripeElementLocale, StripeError } from '@stripe/stripe-js';
import { StripePayment } from "../StripePayment";
import Logger from '../utils/consolelog';
import { AssetsSetting, CardPaymentMethodInfo, LOCAL, PaymentRequestInfo, PaymentType, PromiseResult, StripeAssetsContext, StripeInitStatus, StripPaymentIntentResult, } from '../model';
import CSSStyle from './index.module.css';
import '../index.css';
import { JoinClassName } from "../utils/cssHelper";
import ChowbusStripePaymentProvider from "../ChowbusStripePaymentProvider";

export type StripPaymentRequestElementProps = PropsWithChildren<{
    fetchStripePubKey: () => Promise<{ publicKey: string }>;
    local: LOCAL;
    assets?: AssetsSetting;
    paymentRequestInfo: PaymentRequestInfo;
    onPaymentResult: (error: 'PamentStatusCheckTimeout' | StripeError | null, paymentInfo: {
        paymentType: PaymentType,
        paymentId: string,
        orderId: string,
    }, payerInfo?: {
        payerName?: string;
        payerEmail?: string;
        payerPhone?: string;
    }) => void;
    registerPaymentRequest: (paymentId: string, paymentIntentId: string, createdAt: number,//时间戳,
        payAmount: Number,
        cardPaymentMethodInfo: CardPaymentMethodInfo,

    ) => Promise<PromiseResult>;
    cancelPayment: (paymentId: string) => Promise<PromiseResult>;
    checkPaymentPayStatus: (paymentId: string, orderId: string) => Promise<boolean>;
    createStripePaymentIntent: (payAmount: number) => Promise<StripPaymentIntentResult>;
    onPaymentTypeActived: (paymentType: PaymentType) => void;
    doPaymentBizEnable: () => Promise<boolean>;
    onStripeInitializing: (result: StripeInitStatus) => void;
}>

export function StripePaymentButton(props: StripPaymentRequestElementProps) {
    let { fetchStripePubKey, local, } = props;
    let stripeRef = useRef<Promise<Stripe | null> | null>(null);
    let [stripeLoaded, setStripeLoaded] = useState<StripeInitStatus>(StripeInitStatus.WAITING);

    useEffect(() => {
        let getStripeKey = async () => {
            try {
                let getStripePubKeyAjaxResult = await fetchStripePubKey();
                let { publicKey } = getStripePubKeyAjaxResult;
                if (!stripeRef.current) {
                    let stripePromise = loadStripe(publicKey, {
                        locale: 'en' as StripeElementLocale,
                    });
                    stripeRef.current = stripePromise;
                    setStripeLoaded(StripeInitStatus.SUCCESS);
                }
            } catch (error) {
                Logger('StripePubKey error:', error);
                setStripeLoaded(StripeInitStatus.FAIL);
            }
        };
        getStripeKey();
    }, []);

    // let showPaymentDoing = useCallback(() => {
    //     Logger(LOGPRIX, 'showPaymentDoing');
    //     setShowLoading(true);
    // }, []);

    // let closePaymentDoing = useCallback(() => {
    //     Logger(LOGPRIX, 'closePaymentDoing');
    //     setShowLoading(false);
    // }, []);

    useEffect(() => {
        props.onStripeInitializing(stripeLoaded);
    }, [stripeLoaded, props]);



    return (
        <StripeAssetsContext.Provider value={{
            assetsSetting: props.assets || {
                addNewCreditCardBackground: '',
                entryCardNumberLabelClass: '',
            }
        }}>
            <React.Fragment>
                {
                    stripeLoaded === StripeInitStatus.SUCCESS && <Elements stripe={stripeRef.current}>
                        <ChowbusStripePaymentProvider paymentRequestInfo={props.paymentRequestInfo} >
                            <div className={CSSStyle.container}>
                                <StripePayment
                                    interfaceLocal={local}
                                    onPaymentResult={props.onPaymentResult}
                                    onPaymentTypeActived={props.onPaymentTypeActived}
                                    registerPaymentRequest={props.registerPaymentRequest}
                                    cancelPayment={props.cancelPayment}
                                    createStripePaymentIntent={props.createStripePaymentIntent}
                                    checkPaymentPayStatus={props.checkPaymentPayStatus}
                                    doPaymentBizEnable={props.doPaymentBizEnable}
                                >
                                    {props.children}
                                </StripePayment>
                            </div>
                        </ChowbusStripePaymentProvider>
                    </Elements >
                }
                {
                    stripeLoaded === StripeInitStatus.WAITING && <div className={JoinClassName(CSSStyle.container, CSSStyle.loading)}>
                        <div className={CSSStyle.loading_icon}></div>
                    </div>
                }
            </React.Fragment>
        </StripeAssetsContext.Provider>
    )
}

// export default forwardRef(StripePaymentButton);
// export StripePaymentButton;